<template>
    <div>
      <v-card class="transparent elevation-0">
        <v-container container--fluid grid-list-xl>
           <v-row align="center" justify="space-between">
            <v-col cols="12" md="4">
              <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="text-center" v-if="editPermission">
                <v-tooltip top color="secondary" v-if="newCost">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newCost" v-on="on">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </template>
                  <span>Create a new cost structure</span>
                </v-tooltip>
            </v-col>
           </v-row>
        </v-container>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :search="search"
          :loading="loading"
          :items="renderedCosts"
          :items-per-page="-1"
          >
          <template v-slot:item.shift="props">
            {{ getShiftDisplay(props.value).display }}
          </template>
          <template v-slot:item.cost_type="props">
            {{ getCostTypeDisplay(props.value).display }}
          </template>
          <template v-slot:item.unit_type="props">
            {{ getUnitTypeDisplay(props.value).display }}
          </template>
          <template v-slot:item.actions="props">
            <v-btn icon @click="editRow(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon v-on:click="deleteRow(props.item, $event)">
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog
        v-model="deleteDialog"
        max-width="500px"
      >
        <v-card>
          <v-card-title class="justify-center">
            <h3>ATTENTION</h3>
          </v-card-title>
          <v-card-text class="text-center">
            You are about to delete this cost. This action cannot be undone. <br>
            Are you sure you want to proceed ?
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn text color="blue-grey lighten-2" @click="toBeDeleted=null; deleteDialog=false">No</v-btn>
            <v-btn text color="blue darken-1" @click="deleteCost">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <EditRouteCostStructure
      v-if="cost"
      :cost="cost"
      :region="region"
      :contractor="contractor"
      :unit_types="unit_types"
      :cost_types="cost_types"
      :shift_types="shift_types"
      :editDialog="editDialog"
      ref="editComponent"
      @close="closeEditDialog"
      @save="saveChanges"
      ></EditRouteCostStructure>
    </div>
</template>

<script>
  import axios from 'axios';
  import EditRouteCostStructure from './EditRouteCostStructure';

    export default {
      name: "RouteCostStructureDataTable",
      props: {
        region: Object,
        contractor: {
          default: null,
          type: Object
        }
      },
      components: {
        EditRouteCostStructure
      },
      data() {
        return {
          search: '',
          reload: false,
          loading: false,
          toBeDeleted: null,
          deleteDialog: false,
          editDialog: false,
          cost: null,
          default: {
            id: 0,
            region_id: null,
            region_name: null,
            contractor_id: 0,
            contractor_name: null,
            service_id: 0,
            service_name: null,
            zone_id: 0,
            zone_name: null,
            shift: 'AAA',
            cost_type: null,
            unit_type: null,
            unit_rate: null,
            unit_rate_after: 0,
            unit_rate_before: 0,
            rate_per_units: 1,
            rate_per_units_part_thereof: false,
            effective_date: null,
            fuel_levy:0.0,
          },
          cost_types: [
            {
              "code": "BSE",
              "display": "Base"
            },
            {
              "code": "BNS",
              "display": "Bonus"
            },
            {
              "code": "PEN",
              "display": "Penalty"
            },
            {
              "code": "*",
              "display": "Unknown"
            }
          ],
          unit_types: [
            {
              "code": "RTE",
              "display": "Route"
            },
            {
              "code": "DIS",
              "display": "Distance"
            },
            {
              "code": "DEL",
              "display": "Delivery"
            },
            {
              "code": "BOX",
              "display": "Box"
            },
            {
              "code": "*",
              "display": "Unknown"
            }
          ],
          shift_types: [
            {
              "code": "DAY",
              "display": "Day"
            },
            {
              "code": "OVN",
              "display": "Overnight"
            },
            {
              "code": "AAA",
              "display": "All"
            },
            {
              "code": "*",
              "display": "Unknown"
            }
          ],
        }
      },
      computed: {
        renderedCosts() {
          if (this.costs === null || this.costs === undefined) return [];
          return this.costs;
        },
        editPermission() {
          if (this.region === null) return false;
          if (this.region.id === 0 && this.$store.getters['auth/isAdmin']) return true;
          return this.$store.getters['auth/hasPermissionRegion']('route_cost_structure_edit', this.region);
        },
        headers() {
          let headers = [
            {text: 'Id', value: 'id', align: 'center', sortable: true},
            {text: 'Contractor', value: 'contractor_name', align: 'center', sortable: true},
            {text: 'Service', value: 'service_name', align: 'center', sortable: false},
            {text: 'Shift', value: 'shift', align: 'center', sortable: false},
            {text: 'Zone', value: 'zone_name', align: 'center', sortable: false},
            {text: 'Cost Type', value: 'cost_type', align: 'center', sortable: false},
            {text: 'Unit Type', value: 'unit_type', align: 'center', sortable: false},
            {text: 'Unit Rate', value: 'unit_rate', align: 'center', sortable: false},
            {text: 'Unit Rate After', value: 'unit_rate_after', align: 'center', sortable: false},
            {text: 'Unit Rate Before', value: 'unit_rate_before', align: 'center', sortable: false},
            {text: 'Per Units', value: 'rate_per_units', align: 'center', sortable: false},
            {text: 'Fuel Levy', value: 'fuel_levy', align: 'center', sortable: false},
            {text: 'Effective Date', value: 'effective_date', align: 'center', sortable: false},
          ];
          if (this.editPermission) headers.push({text: 'Actions', value: 'actions', align: 'center', sortable: false});
          return headers;
        }
      },
      asyncComputed: {
        async costs() {
          if (this.reload || !this.reload) {
            if (this.region === null ||(this.region.id !== 0 && !this.$store.getters['auth/hasPermissionRegion']('route_cost_structure_view', this.region))) {
              this.reload = false;
              return [];
            }
            this.loading = true;
            let path = process.env.API_URL;
            if (this.contractor === null) {
              path += '/regions/' + this.region.id + '/routecosts';
            } else {
              path += '/contractors/' + this.contractor.id + '/routecosts';
            }
            return await axios.get(path)
              .then((response) => {
                if (response.status === 200) {
                  this.loading = false;
                  this.reload = false;
                  return response.data;
                } else {
                  this.loading = false;
                  return [];
                }
              })
              .catch((error) => {
                this.reload = false;
                this.loading = false;
                return [];
              });
          }
        }
      },
      methods: {
        getUnitTypeDisplay(unit) {
          return this.unit_types.find(function (e) {
            return e.code === unit || e.code === "*";
          })
        },
        getCostTypeDisplay(cost) {
          return this.cost_types.find(function (e) {
            return e.code === cost || e.code === "*";
          })
        },
        getShiftDisplay(shift) {
          return this.shift_types.find(function (e) {
            return e.code === shift || e.code === "*";
          })
        },
        newCost() {
          this.cost = Object.assign({}, this.default);
          if (this.region !== null) {
            this.cost.region_id = this.region.id;
            this.cost.region_name = this.region.name;
          }
          if (this.contractor !== null) {
            this.cost.contractor_id = this.contractor.id;
            this.cost.contractor_name = this.contractor.name;
          }
          this.editDialog = true;
        },
        editRow(item) {
          this.cost = Object.assign({}, item);
          this.editDialog = true;
        },
        deleteRow(item, event) {
          this.toBeDeleted = item;
          this.deleteDialog = true;
          if (event) event.cancelBubble = true;
        },
        deleteCost() {
          axios.delete(process.env.API_URL + '/routecosts/' + this.toBeDeleted.id)
            .then((response) => {
              this.toBeDeleted = null;
              this.deleteDialog = false;
              this.reload = true;
                this.$store.commit('displaySnackbar', 'Delete successful');
            })
            .catch((error) => {
                this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
            });
        },
        toggleDeleteDialog(item) {
          this.toBeDeleted = item;
          this.deleteDialog = true;
        },
        closeEditDialog() {
          this.editDialog = false;
          this.cost = null;
        },
        saveChanges() {
          if (this.cost.id > 0) {
            axios.put(process.env.API_URL + '/routecosts/' + this.cost.id, this.cost)
              .then((response) => {
                this.editDialog = false;
                this.cost = null;
                this.reload = true;
                  this.$store.commit('displaySnackbar', 'Save successful');
              })
              .catch((error) => {
                  this.$store.commit('displaySnackbar', 'ERROR: Save failed');
              });
          } else {
            axios.post(process.env.API_URL + '/routecosts', this.cost)
              .then((response) => {
                this.editDialog = false;
                this.cost = null;
                this.reload = true;
                  this.$store.commit('displaySnackbar', 'Create successful');
              })
              .catch((error) => {
                  this.$store.commit('displaySnackbar', 'ERROR: Create failed');
              });
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Routes/RouteCostStructureDataTable.vue